module.exports = __webpack_public_path__ + "img/6.b381d1f4.jpg";